// src/lib/firebase/database/auth/roles.ts
import { collection, doc, getDoc, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../../config';

export const getUserRole = async (uid: string): Promise<'admin' | 'guide' | 'organizer'> => {
  try {
    // First, try to find the user in the Users collection (for admin)
    const userDoc = await getDoc(doc(firestore, 'Users', uid));
    if (userDoc.exists()) {
      return 'admin';
    }

    // Then, try to find the user in the Guides collection
    const guideDoc = await getDoc(doc(firestore, 'Guides', uid));
    if (guideDoc.exists()) {
      return 'guide';
    }

    // Finally, try to find the user in the Organizers collection
    const organizerDoc = await getDoc(doc(firestore, 'Organizers', uid));
    if (organizerDoc.exists()) {
      return 'organizer';
    }

    // If user not found in any of the collections, default to admin
    // This is a fallback to prevent login errors
    console.warn('User role not found, defaulting to admin:', uid);
    return 'admin';
  } catch (error) {
    console.error('Error determining user role:', error);
    // Default to admin role when there's an error to ensure user can still access the system
    return 'admin';
  }
};

// Get role info
export const getRoleInfo = async (roleId: string) => {
  try {
    const docRef = doc(firestore, 'Roles', roleId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data()
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching role:', error);
    return null;
  }
};
